// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"af8a3a0b","498":"44e2828a","703":"ae192649","787":"f91cffa0"}[chunkId] + ".chunk.js";
};